import './App.css';
import TitleBar from './components/titlebar.js';
import LabelBar from './components/LabelBar.js';
import Design from './components/design';
import React from 'react';
import Sick from './components/sick.js';
import Art from './components/art.js';

import {render} from 'react-dom';
import Engine from './components/engine';






function App() {
  const sendToTop=()=>{
    document.body.scrollTop = 0; 
    document.documentElement.scrollTop = 0;
    console.log("shitfuck");
  }

  return (
  <>
    <div className="appControl" >
      <TitleBar/>
      <LabelBar/>
      <Sick/>
      <Design/>
      <Art/>
      <Engine/>
      <div className="bottomBar">
        <h4>Contact</h4>
        <p>instagram: @diesent__</p>
        <p>email: joshdiesenhaus@gmail.com</p>
        <div>
          <button id="btn" className="btn" type="button" onClick={sendToTop}>back to top</button>
        </div>
        
      </div>
    </div>
  </>
  );
}

export default App;
